import React from 'react';
import PropTypes from 'prop-types';
import {genericMandarkRequest, invalidatePartialInterest} from 'resources/mandark.resource';
import {getModelForResourceType} from 'resources/modelRegistry';
import sessionStore from 'client/Session/SessionStore';
import {resource} from '@albert-io/json-api-framework/request/builder';
import {Anchor, addToast, Button, Dialogue, Modal, TextField} from '@albert-io/atomic';

export default class DuplicateFolderModal extends React.Component {
  static propTypes = {
    folder: PropTypes.instanceOf(getModelForResourceType('template_v1')),
    handleClose: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      name: `Copy of ${props.folder.getName()}`
    };
  }

  handleInputChange = (e) => {
    this.setState({name: e.target.value});
  };

  duplicateFolder = async () => {
    const {folder} = this.props;
    const folderId = folder.getId();
    const folderName = this.state.name;

    try {
      await genericMandarkRequest(
        'post',
        resource('templates_v1')
          .mandarkEndpoint(['templates_v1', 'copy_template', folderId])
          .done(),
        {
          data: {
            attributes: {
              name: folderName
            },
            relationships: {
              teacher_v1: {
                data: {
                  id: sessionStore.getUserId(),
                  type: 'teacher_v1'
                }
              }
            }
          }
        }
      );
      invalidatePartialInterest({resourcePath: ['templates_v1']});
      const toastAnchor = (
        <Anchor underlined inheritColor href='/saved'>
          folders list
        </Anchor>
      );
      const message = <span>This folder was successfully copied to your {toastAnchor}.</span>;
      addToast({
        title: 'Success!',
        type: 'success',
        message,
        duration: 2500
      });
    } catch (error) {
      addToast({
        title: 'Something went wrong',
        type: 'danger',
        message: 'There was a problem with duplicating your folder.'
      });
    } finally {
      this.props.handleClose();
    }
  };

  render() {
    return (
      <Modal ariaLabel='Name duplicate folder modal' handleClose={this.props.handleClose}>
        {({CloseButtonWrapper}) => {
          return (
            <Dialogue
              inModal
              className='duplicate-folder-modal'
              handleClose={this.props.handleClose}
              paddingLevel={3}
            >
              <Dialogue.Body className='u-mar-t_2'>
                <TextField
                  border
                  defaultValue={this.state.name}
                  label='Name your folder'
                  placeholder='Folder name'
                  onChange={this.handleInputChange}
                />
              </Dialogue.Body>
              <Dialogue.BtnGroup>
                <CloseButtonWrapper>
                  <Button onClick={this.props.handleClose} color='secondary'>
                    Cancel
                  </Button>
                </CloseButtonWrapper>
                <Button onClick={this.duplicateFolder} disabled={this.state.name === ''}>
                  Create a copy
                </Button>
              </Dialogue.BtnGroup>
            </Dialogue>
          );
        }}
      </Modal>
    );
  }
}
